/**
 * @file footerbar
 * @author wangzhuang
 */

import React, {Component} from 'react';
import PropType from 'prop-types';
import {connect} from 'react-redux';

import './index.less';

class TopBar extends Component {
    static propTypes = {
        pagesDatabyid: PropType.object
    }

    isHaomaPage = () => {
        const pagesDatabyid = this.props.pagesDatabyid;
        let pageType = '';
        if (pagesDatabyid) {
            const pagesCommon = pagesDatabyid && pagesDatabyid.itemlist && pagesDatabyid.itemlist.pages_common;
            pageType = pagesCommon && pagesCommon.page_type;
        }
        const path = location.pathname || '';

        return pageType === '5001' || /\/haoma\//.test(path);
    }

    sendData = () => {
        const pagesDatabyid = this.props.pagesDatabyid;
        const pagesCommon = pagesDatabyid
            && pagesDatabyid.itemlist
            && pagesDatabyid.itemlist.pages_common;
        const navName = pagesCommon && pagesCommon.navigation_name;
        if (
            this.isPageTitle('mesatee', navName)
        ) {
            this.reportData('mesatee_banner');
        }
        const pageId = pagesCommon.id;
        window.open(`/m/apply/${pageId}`, '_blank');
    }

    render() {
        return (
            <div className={'footer-bar'}>
                {!this.isHaomaPage()
                    && <div className={'footer-goodness align-center'}>
                        <div>7x24小时</div>
                        <div>专业化团队</div>
                        <div>企业级SRC</div>
                    </div>}
                <div className={'footer-itemize'}>
                    <ul>
                        <li><a href="https://anquan.baidu.com/?type=web">切换至电脑版</a></li>
                        {/*<li><a href="/m/">百度安全品牌升级</a></li>*/}
                        <li><a
                            // href=""
                            onClick={this.sendData}
                            // target={'_banlk'}
                        >申请试用</a></li>
                        {!this.isHaomaPage()
                            && <li>商务咨询 <a href="tel://010-58003138" className={'footer-phone'}>010-58003138</a></li>}
                        <li>
                            <a
                                onClick={this.sendData}
                                className="footer-apply"
                                // href="/m/apply"
                                // target={'_banlk'}
                            >立即咨询</a>
                        </li>
                    </ul>
                    <div className={'footer-wechat'}>
                        <div>关注我们</div>
                        <img src={require('../../asset/image/home/weChat.jpg')} alt="关注我们" />
                    </div>
                </div>
                <div className={'footer-tips'}>
                    ©2020 Baidu <a href="https://www.baidu.com/duty/">使用百度前必读</a> 京ICP证030173号
                </div>
            </div>
        );
    }
}
export default connect(state => ({pagesDatabyid: state.pagesDatabyid}))(TopBar);



// WEBPACK FOOTER //
// ./src/components/FooterBar/index.js